import { QueryClient } from '@tanstack/react-query';

import { isDjangoErrorResponse } from 'api/common';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchInterval: false,
      refetchIntervalInBackground: false,
      retryOnMount: false,
      retry: (failureCount, error) => {
        if (isDjangoErrorResponse(error) && error.code === 'approve_required') {
          return false;
        }

        if (import.meta.env.DEV) {
          return false;
        }

        return failureCount < 3;
      },
    },
  },
});
